module.exports = __webpack_public_path__ + "static/media/06.03bf6b78.jpg";